// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/collapse/style/index.less
// module id = 1106
// module chunks = 0